import * as api from "../../../api/index";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { KeyboardArrowLeft, LibraryAddOutlined } from "@material-ui/icons";

import { ALERT, REMOVE_NEW_QUOTE } from "../../../constants/actionTypes";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import "./Project.css";

const Project = ({
  showProject,
  setShowProject,
  quote,
  user,
  setUser,
  section,
}) => {
  dayjs.extend(relativeTime);
  const dispatch = useDispatch();
  const history = useHistory();
  const [files, setFiles] = useState([]);
  const [translations, setTranslations] = useState([]);
  const [uploads, setUploads] = useState([]);
  const [size, setSize] = useState(0);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("");
  const [infoType, setInfoType] = useState("");
  const [message, setMessage] = useState("");
  const [accepting, setAccepting] = useState(false);
  const [declining, setDeclining] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const disable = accepting || declining || uploading || loading;
  const reveiwing = user.workPlace.reveiwing
    ? user.workPlace.reveiwing.includes(quote.id)
    : false;
  const translationFiles = loading
    ? []
    : reveiwing
    ? translations.filter(
        (translation) => translation.translator.email === user.email
      )[0].files
    : uploads;
  const totalSize = reveiwing
    ? translationFiles.reduce((acc, curr) => acc + curr.size, 0)
    : size;
  const errorMsg = user.workPlace.decline_msg
    ? user.workPlace.decline_msg.filter((msg) => msg.quote === quote.id)
    : [];

  const openModal = (type) => {
    setType(type);
    document.querySelector(".project__details").style.zIndex = 4;
    document.querySelector(".project__details").open = true;
  };

  const closeModal = () => {
    setType("");
    document.querySelector(".project__details").style.zIndex = -1;
    document.querySelector(".project__details").open = false;
  };

  const handleChange = (e) => {
    const toBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const uploadedFiles = Array.from(e.target.files);
    const totalSize =
      uploadedFiles.reduce((acc, curr) => acc + curr.size, 0) +
      uploads.reduce((acc, curr) => acc + curr.size, 0);
    const rejectedFiles = uploadedFiles.filter(
      (file) =>
        file.name.substr(file.name.lastIndexOf("."), file.name.length) !==
        ".pdf"
    );
    if (rejectedFiles.length > 0)
      return dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "Only a PDF file can be uploaded",
          duration: 7000,
          display: true,
        },
      });
    if (totalSize > 12000000)
      return dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "Files can not be larger than 12MB",
          duration: 7000,
          display: true,
        },
      });

    const refinedFiles = async () => {
      const fileUrl = [];
      uploadedFiles.forEach((file) => {
        fileUrl.push(toBase64(file));
      });
      const fileUrls = await Promise.all(fileUrl);
      const newFiles = fileUrls.map((base64File, index) => ({
        base64: base64File,
        size: uploadedFiles[index].size,
        name: uploadedFiles[index].name.substr(
          0,
          uploadedFiles[index].name.lastIndexOf(".")
        ),
        type: uploadedFiles[index].name.substr(
          uploadedFiles[index].name.lastIndexOf(".") + 1,
          uploadedFiles[index].name.length
        ),
      }));
      setUploads([...uploads, ...newFiles]);
      return newFiles;
    };

    setSize(totalSize);
    refinedFiles();
  };

  const handleRemove = (i) => {
    const removedFile = uploads.filter((upload, index) => index !== i);
    setSize(removedFile.reduce((acc, curr) => acc + curr.size, 0));
    setUploads(removedFile);
  };

  const handleShowInfo = (type) => {
    setInfoType(type);
    setShowMessage(true);
  };

  const handleAccept = async () => {
    setAccepting(true);
    const contributorId = quote.contributors.filter(
      (contributor) => contributor.translator.email === user.email
    )[0]._id;

    try {
      await api.updateUser(user._id, {
        $pull: { "workPlace.new_projects": quote.id },
        $push: { "workPlace.ongoing_projects": quote.id },
      });
      await api.awaiting({ $pull: { awaiting_projects: contributorId } });
      setUser({
        ...user,
        workPlace: {
          ...user.workPlace,
          new_projects: user.workPlace.new_projects.filter(
            (project) => project !== quote.id
          ),
          ongoing_projects: user.workPlace.ongoing_projects
            ? user.workPlace.ongoing_projects.concat(quote.id)
            : [quote.id],
        },
      });
      history.push("/translator/index");
      dispatch({ type: REMOVE_NEW_QUOTE, id: quote.id });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setAccepting(false);
    }
  };

  const handleDecline = async () => {
    setDeclining(true);
    const contributors = quote.contributors.filter(
      (contributor) => contributor.translator.email !== user.email
    );
    const contributorId = quote.contributors.filter(
      (contributor) => contributor.translator.email === user.email
    )[0]._id;

    try {
      await api.updateUser(user._id, {
        $pull: { "workPlace.new_projects": quote.id },
      });
      await api.updateQuote(quote.id, {
        $push: {
          "allocation.declined_lang": user.target_lang,
          "allocation.declined_msg": {
            message,
            translator: user.email,
            language: user.target_lang,
            createdAt: new Date(),
          },
        },
        "allocation.declined": true,
        contributors,
      });
      await api.awaiting({ $pull: { awaiting_projects: contributorId } });
      if (quote.allocation.declined === false || !quote.allocation.decline)
        await api.counter({ declined_allocations: 1 });
      setUser({
        ...user,
        workPlace: {
          ...user.workPlace,
          new_projects: user.workPlace.new_projects.filter(
            (project) => project !== quote.id
          ),
        },
      });
      history.push("/translator/index");
      dispatch({ type: REMOVE_NEW_QUOTE, id: quote.id });
    } catch (error) {
      console.log(error);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setDeclining(false);
    }
  };

  const handleUpload = async () => {
    setUploading(true);
    const translations = {
      files: uploads,
      translator: {
        id: user._id,
        email: user.email,
        name: user.name,
      },
      language: user.target_lang,
    };

    try {
      await api.updateUser(user._id, {
        $push: { "workPlace.reveiwing": quote.id },
      });
      await api.updateQuote(quote.id, {
        $push: { translations },
        $inc: { "tracker.translation": 1 },
      });
      await api.counter({ completed_projects: 1 });
      history.push("/translator/index");
      setUser({
        ...user,
        workPlace: {
          ...user.workPlace,
          reveiwing: user.workPlace.reveiwing
            ? [...user.workPlace.reveiwing, quote.id]
            : [quote.id],
        },
      });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
        console.log(error);
      }
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    const getFile = async () => {
      try {
        const { data } = await api.getFiles(quote.id);
        setFiles(data.files);
        if (reveiwing) {
          const translation = await api.getTranslations(quote.id);
          setTranslations(translation.data.translations);
        }
      } catch (error) {
        if (error.response)
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: error.response.data.message,
              duration: 5000,
              display: true,
            },
          });
        else
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: "An unexpected error occurred",
              duration: 5000,
              display: true,
            },
          });
      } finally {
        setLoading(false);
      }
    };
    if (showProject && quote) getFile();

    return () => setFiles([]);
  }, [showProject, quote, reveiwing, dispatch]);

  return (
    <>
      <div className="project position-fixed t-0 r-0 overflow-auto h-100 z-3">
        <h2
          className="project__head d-flex align-center font-subhead p-40 pointer"
          onClick={() => setShowProject(false)}
        >
          <KeyboardArrowLeft style={{ fontSize: "45px" }} />
          {section === "new" && "New Project"}
          {section === "ongoing" && "Ongoing Project"}
          {section === "declined" && "Declined Project"}
        </h2>
        <div className="project__scroll">
          <div className="project__top project__min__width d-flex justify-between p-40 f-100">
            <div className="project__left f-40">
              <h3 className="mb-20">Project Details</h3>
              <div className="d-flex py-20">
                <span className="font-bold">Project Name</span>
                <span>{quote.projectName}</span>
              </div>
              <div className="d-flex py-20">
                <span className="font-bold">Project ID</span>
                <span>{quote.quote_id}</span>
              </div>
              <div className="d-flex py-20">
                <span className="font-bold">Translation</span>
                <span>
                  {quote.languageFrom} - {quote.languageTo.join(", ")}
                </span>
              </div>
              <div className="d-flex py-20">
                <span className="font-bold">Subject</span>
                <span>{quote.subject}</span>
              </div>
              <div className="d-flex py-20">
                <span className="font-bold">Delivery Date</span>
                <span>
                  {dayjs(quote.reviewDate).format("dddd, MMMM D YYYY")}
                </span>
              </div>
              <div className="d-flex py-20">
                <span className="font-bold">Allocated on</span>
                <span>
                  {dayjs(
                    quote.contributors.filter(
                      (contributor) =>
                        contributor.translator.email === user.email
                    )[0].createdAt
                  ).format("dddd, MMMM D YYYY")}
                </span>
              </div>
            </div>
            <div className="project__right f-70">
              <div>
                <h3 className="px-40 py-5">Project Documents</h3>
                <div className="grid c-4 px-40 pt-40 pb-20">
                  <span className="font-bolder">File Name</span>
                  <span className="font-bolder">Document Type</span>
                  <span className="font-bolder">
                    {quote.totalPages ? "Pages" : "Words"}
                  </span>
                  <span className="font-bolder">Size</span>
                </div>
                {loading ? (
                  <div className="fading__ctn grid c-4">
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20 ellipsis"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                  </div>
                ) : (
                  <>
                    {files.map((file) => (
                      <div
                        className="project__file__info font-big grid c-4 py-10 px-40 font-sm align-start"
                        key={file._id}
                      >
                        <span>
                          {file.name.substr(0, file.name.lastIndexOf("."))}
                        </span>
                        <span className="text-uppercase">
                          {file.name.substr(
                            file.name.lastIndexOf(".") + 1,
                            file.name.length
                          )}
                        </span>
                        <span>{quote.totalPages ? file.page : file.count}</span>
                        <div className="d-flex align-center justify-between">
                          <span>
                            {file.size < 1000
                              ? `${file.size} B`
                              : file.size > 999999.9
                              ? `${(file.size / 1000000).toFixed(1)} MB`
                              : `${(file.size / 1000).toFixed(1)} KB`}
                          </span>
                          {(section === "ongoing" ||
                            section === "declined") && (
                            <a
                              download={`${file.name.substr(
                                0,
                                file.name.lastIndexOf(".")
                              )}(${quote.projectName})-NT`}
                              href={file.base64}
                            >
                              <button className="project__file__btn border-0 outline-0 rounded py-5 px-10 font-bold">
                                Download
                              </button>
                            </a>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div>
                <div className="grid c-3 font-bolder mt-40 mb-20 px-40 py-10">
                  <span>Quantity</span>
                  <span>Unit Price</span>
                  <span>USD</span>
                </div>
                {loading ? (
                  <div className="fading__ctn grid c-3">
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                  </div>
                ) : (
                  <div className="project__grey font-big grid c-3 py-10 px-40 font-sm align-start">
                    <span>
                      {quote.totalPages
                        ? `${quote.totalPages}${
                            quote.totalPages > 1 ? "s" : ""
                          }`
                        : `${quote.totalCount} words`}
                    </span>
                    <span>
                      {quote.contributors
                        .filter(
                          (contributor) =>
                            contributor.translator.email === user.email
                        )[0]
                        .price.toFixed(2)}
                    </span>
                    <span>
                      {quote.contributors
                        .filter(
                          (contributor) =>
                            contributor.translator.email === user.email
                        )[0]
                        .amount.toFixed(2)}
                    </span>
                  </div>
                )}
              </div>
              <div className="d-flex justify-end p-5">
                {section === "declined" && (
                  <button
                    style={{ backgroundColor: "crimson" }}
                    className="project__btn__msg border-0 outline-0 p-5"
                    onClick={() => handleShowInfo("decline")}
                  >
                    Decline messages
                  </button>
                )}
                {quote.translatorNote !== "" && (
                  <button
                    className="project__btn__note border-0 outline-0 py-5 px-20 ml-10"
                    onClick={() => handleShowInfo("note")}
                  >
                    Note
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="project__bottom project__min__width">
            {section === "new" && (
              <div className="d-flex justify-center py-40">
                <button
                  style={{ opacity: loading ? "0.6" : "" }}
                  className="outline-0 border-0 rounded p-10 w-45 font-bold font-big mr-20"
                  onClick={() => openModal("accept")}
                  disabled={loading}
                >
                  ACCEPT
                </button>
                <button
                  style={{ opacity: loading ? "0.6" : "" }}
                  className="outline-0 border-0 rounded p-10 w-45 font-bold font-big ml-20"
                  onClick={() => openModal("decline")}
                  disabled={loading}
                >
                  DECLINE
                </button>
              </div>
            )}
            {(section === "ongoing" || section === "declined") &&
              uploads.length < 1 &&
              !reveiwing && (
                <div className="d-flex justify-center">
                  <label className="my-40">
                    <input
                      className="position-absolute hidden"
                      type="file"
                      accept=".pdf"
                      onChange={handleChange}
                      disabled={loading}
                      multiple
                    />
                    <div
                      style={{ opacity: loading ? "0.6" : "" }}
                      className="project__upload d-flex align-center justify-center outline-0 border-0 rounded p-10 font-bold font-big pointer"
                    >
                      <LibraryAddOutlined className="mr-10" />
                      UPLOAD
                    </div>
                  </label>
                </div>
              )}
            {(((section === "ongoing" || section === "declined") &&
              uploads.length > 0) ||
              reveiwing) && (
              <div className="mb-40">
                <h3 className="px-40 mx-40 py-5">Project Documents</h3>
                <div className="grid c-4 px-40 mx-40 pt-40 pb-20">
                  <span className="font-bolder">File Name</span>
                  <span className="font-bolder">Document Type</span>
                  <span className="font-bolder">Size</span>
                </div>
                {loading ? (
                  <div className="fading__ctn grid c-3 mx-40">
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                    <span
                      style={{ height: "53px" }}
                      className="fade p-20"
                    ></span>
                  </div>
                ) : (
                  <>
                    {translationFiles.map((upload, index) => (
                      <div
                        className="project__uploads__row font-big grid align-center c-4 py-10 px-40 mx-40 font-sm"
                        key={upload.name.concat(index)}
                      >
                        <span className="text-capitalise">{upload.name}</span>
                        <span className="text-uppercase">{upload.type}</span>
                        <span>
                          {upload.size < 1000
                            ? `${upload.size} B`
                            : upload.size > 999999.9
                            ? `${(upload.size / 1000000).toFixed(1)} MB`
                            : `${(upload.size / 1000).toFixed(1)} KB`}
                        </span>
                        {!reveiwing && (
                          <button
                            className="projects__remove__btn outline-0 border-0 rounded p-10 w-75 font-bold font-normal hidden"
                            onClick={() => handleRemove(index)}
                          >
                            Remove
                          </button>
                        )}
                        {reveiwing && (
                          <a
                            download={`${upload.name}(${quote.projectName})-NT`}
                            href={upload.base64}
                          >
                            <button className="projects__preview__btn outline-0 border-0 rounded p-10 w-75 font-bold font-normal hidden">
                              Preview
                            </button>
                          </a>
                        )}
                      </div>
                    ))}
                  </>
                )}
                {!reveiwing && (
                  <label
                    style={{ width: "fit-content" }}
                    className="d-flex justify-end pt-10 mx-40 ml-auto"
                  >
                    <input
                      className="position-absolute r-0 hidden"
                      type="file"
                      accept=".pdf"
                      onChange={handleChange}
                      disabled={loading}
                      multiple
                    />
                    <div
                      style={{ opacity: loading ? "0.6" : "" }}
                      className="project__upload__sm d-flex align-center justify-center outline-0 border-0 rounded p-5 font-bold pointer"
                    >
                      <LibraryAddOutlined className="mr-10" />
                      ADD FILES
                    </div>
                  </label>
                )}
                <div className="project__uploads__summary__top grid align-center c-4 px-40 py-10 mx-40 mt-20">
                  <span className="font-bolder">Project Name</span>
                  <span className="font-bolder">Documents Type</span>
                  <span className="font-bolder">Total size</span>
                </div>
                <div className="project__uploads__summary font-big grid align-center c-4 py-10 px-40 mx-40 font-sm">
                  <span>{quote.projectName}</span>
                  <span>PDF</span>
                  <span>
                    {totalSize < 1000
                      ? `${totalSize} B`
                      : totalSize > 999999.9
                      ? `${(totalSize / 1000000).toFixed(1)} MB`
                      : `${(totalSize / 1000).toFixed(1)} KB`}
                  </span>
                  {!reveiwing && (
                    <button
                      style={{ opacity: uploads.length < 1 ? "0.6" : "" }}
                      className="outline-0 border-0 rounded p-10 w-75 font-bold font-normal"
                      onClick={() => openModal("upload")}
                      disabled={uploads.length < 1}
                    >
                      Submit
                    </button>
                  )}
                  {reveiwing && (
                    <p className="font-big font-bolder italics px-10 rounded">
                      In review
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        style={{ right: showMessage ? 0 : "" }}
        className="allocate__declined__msg position-fixed h-100 t-0 z-4 overflow-auto"
      >
        <h3
          className="position-sticky d-flex align-center p-20 pointer border-bottom-1 t-0"
          onClick={() => setShowMessage(false)}
        >
          <KeyboardArrowLeft style={{ fontSize: "36px" }} />
          {infoType === "decline" && "Decline Message"}
          {infoType === "note" && "Note"}
        </h3>
        {infoType === "decline" &&
          errorMsg.map((msg) => (
            <div
              className="d-flex flex-column px-20 py-10 border-bottom-1"
              key={msg.message}
            >
              <span className="font-bold font-big">Admin</span>
              <span className="lh-lg">{msg.message}</span>
              <time className="font-sm font-bolder text-right">
                {dayjs(msg.createdAt).fromNow()}
              </time>
            </div>
          ))}
        {infoType === "note" && (
          <div className="d-flex flex-column px-20 py-10">
            <span className="font-bold font-big">Translator's Note</span>
            <span className="lh-lg">{quote.translatorNote}</span>
          </div>
        )}
      </div>
      <details className="project__details position-fixed">
        <summary className="list-none"></summary>
        <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
          <div className="d-flex flex-column align-center text-center p-20">
            {type === "accept" && (
              <h3 className="font-subhead">
                Accept Project {quote.projectName}
              </h3>
            )}
            {type === "decline" && (
              <h3 className="font-subhead">
                Decline Project {quote.projectName}
              </h3>
            )}
            {type === "upload" && (
              <h3 className="font-subhead">
                Upload Files for Project {quote.projectName}
              </h3>
            )}
            {type === "accept" && (
              <p className="font-heavy font-big py-40">
                By accepting you agree with our terms and condition, and
                submission of project on or before{" "}
                <strong>
                  {dayjs(quote.reviewDate).format("dddd, MMMM D YYYY")}
                </strong>
              </p>
            )}
            {type === "decline" && (
              <div>
                <p className="font-heavy font-big py-10">
                  Please let us know why you are declining
                </p>
                <textarea
                  className="mt-10 mb-40 w-100 border-0 outline-0 p-10 border-1 box-shadow-lg"
                  placeholder="..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            )}
            {type === "upload" && (
              <p className="font-heavy font-big py-40">
                Document is subjected to approval after submission and can be
                returned for correction
              </p>
            )}
            <div className="d-flex justify-between">
              <button
                className="project__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                onClick={closeModal}
                disabled={disable}
              >
                Cancel
              </button>
              {type === "accept" && (
                <button
                  style={{ opacity: accepting ? "0.6" : "" }}
                  className="project__btn__accept d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleAccept}
                  disabled={disable}
                >
                  Accept
                  {accepting && <div className="spin-white ml-10"></div>}
                </button>
              )}
              {type === "decline" && (
                <button
                  style={{
                    opacity: declining || message.trim() === "" ? "0.6" : "",
                  }}
                  className="project__btn__decline d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleDecline}
                  disabled={disable || message.trim() === ""}
                >
                  Decline
                  {declining && <div className="spin-white ml-10"></div>}
                </button>
              )}
              {type === "upload" && (
                <button
                  style={{
                    opacity: uploads.length < 1 || disable ? "0.6" : "",
                  }}
                  className="project__btn__accept d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleUpload}
                  disabled={uploads.length < 1 || disable}
                >
                  Upload
                  {uploading && <div className="spin-white ml-10"></div>}
                </button>
              )}
            </div>
          </div>
        </div>
      </details>
    </>
  );
};

export default Project;
